/** @module Specification/SharedSpecSectionController */
define(["dojo/_base/declare", "csi/table/Widget"], function(declare, Widget) {
	return declare(Widget, {
		/** @property {reflist} selectedSharedSpecSections */
		selectedSharedSpecSections: null,

		/**
		 * @override
		 * Update list of selected shared sections
		 */
		onViewCreate: function() {
			this.watch("selectedSharedSpecSections", (name, oldValue, newValue) => {
				this.selectedSharedSpecSections = newValue;
			});
			this.inherited(arguments);
		},
	});
});
